export default __webpack_public_path__ + "static/media/guide_01_02.1671a078.png";